import * as React from "react";
import { forwardRef } from "react";
const SvgSovBgDesktop = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 1728, height: 295, fill: "currentColor", viewBox: "0 0 1728 295", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M938.125 144.033C659.597 40.175 218.004-76.467 0 67.337v226.891h1728V102.489c-170.45 48.467-567.05 124.63-789.875 41.544" }));
const ForwardRef = forwardRef(SvgSovBgDesktop);
export default ForwardRef;
